import { Popover } from "@/components/Popover/Popover";
import DogIcon from "@medoma/components/icons/DogIcon";
import { useLingui } from "@lingui/react/macro";
import { TextWithLineBreaks } from "@medoma/components/Text/Text";
import styles from "./PetPopover.module.scss";

export const PetPopover = ({ details }: { details: string }) => {
  const { t } = useLingui();

  return (
    <Popover
      trigger={{
        custom: (
          <div className={styles.petIcon}>
            <DogIcon />
          </div>
        ),
        ariaLabel: t`Visa information om husdjur`,
      }}
    >
      <TextWithLineBreaks>{details}</TextWithLineBreaks>
    </Popover>
  );
};
